import React from 'react';
export function WhatIsHardMillingSection() {
  return <section data-id="element-2481">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2482">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2483">
          What is Hard Milling?
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-2484">
        <p data-id="element-2485">
          Hard milling is a specialized machining process that allows machine
          shops to mill parts that have a Rockwell hardness of up to 64.
        </p>
        <p data-id="element-2486">
          The process of hard milling is very similar to normal machining;
          however, it requires special equipment and understanding of material
          hardness, machining capabilities, tooling, and tool holding devices.
        </p>
        <p data-id="element-2487">
          Hard milling was first used to re-machine parts that were previously
          heat treated (made harder to increase performance or life expectancy)
          and which needed additional machining or changes. It quickly turned
          into an independent machining process.
        </p>

        <div className="pt-4" data-id="element-2488">
          <p className="font-bold text-navy mb-3" data-id="element-2489">
            The main drivers for hard milling as an independent process are:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2490">
            <li data-id="element-2491">
              The need for quicker turnaround on mold and die components (faster
              time to market).
            </li>
            <li data-id="element-2492">
              The cost and time intensity of EDMing (electronic discharge
              machining), surface grinding, and jig grinding.
            </li>
            <li data-id="element-2493">
              The availability of newer pre-hardened materials such as P20, H13,
              4140, etc.
            </li>
            <li data-id="element-2494">Improvements in CAD/CAM and 3D machining.</li>
            <li data-id="element-2495">
              Dramatic improvements in machines, machine tools (cutters), and
              tool holding devices.
            </li>
            <li data-id="element-2496">
              An ever-increasing need to manufacture replacement or new tooling
              components, reduce lead times, and improve surface finishes.
            </li>
          </ul>
        </div>

        <p className="pt-4" data-id="element-2497">
          Hard milling machines need to have high static and dynamic rigidity.
          Machine bases are made of polymer concrete in monolithic construction
          to absorb vibrations and help dampening, ensuring high cutting speeds
          to generate great surface finishing and cutting tool utilization.
          Glass scales are needed to ensure accuracy as well as machine controls
          that can handle the higher feed rates and true positioning.
        </p>
      </div>
    </section>;
}